import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n  html {\n    height: 100%;\n    color: ", ";\n    background-color: ", ";\n    font-family: ", ";\n    font-size: 16px;\n    -webkit-tap-highlight-color: transparent;\n    box-sizing: border-box;\n    body {\n      height: 100%;\n      margin: 0;\n      padding: 0;\n      overflow-x: hidden;\n      #root {\n        height: 100%;\n      }\n      &.modal-opened {\n        overflow-y: hidden;\n      }\n    }\n  }\n  span, p, h1, h2, h3, h4, h5, h6, label, i, button {\n    color: inherit;\n    margin: 0px;\n  }\n  ul {\n    list-style-type: none;\n  }\n  ul, li {\n    margin: 0;\n    padding: 0;\n  }\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n  button {\n    border: none;\n    outline: none;\n  }\n  .sortableHelper {\n    z-index: 10000 !important;\n    transition: box-shadow 500ms ease-in-out;\n    box-shadow: 0 4px 10px 4px rgba(0, 0, 0, 0.15);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from "styled-components";
import { font } from "./Constants";
export var GlobalStyle = createGlobalStyle(_templateObject(), function (props) {
  return props.theme.color("text", "primary");
}, function (props) {
  return props.theme.color("background", "primary");
}, font("text"));
export default GlobalStyle;